<app-user-header class="d-md-none"></app-user-header> 


<div class="wrapperi">
  <div class="p-4">
    <div class="col-12">

      <div class="pointer" (click)="goBack()">
          <p class="semiboldtextblue16 mb-0"><i class="fal normaltextblue16 fa-chevron-left icon-blue me-2"></i>Takaisin</p>
      </div>
  </div>
  </div>

  <div class="ps-4 pe-4 pt-2">
    <div class="bg-w formed-shadow">
      <div class="p-4">
    <div class="col-12  p-0 input-cover ">
        <div class="col-12 p-0">
          <p class="semiboldtextblue24">Muokkaa tietoja</p>

      </div>

      <div class="col-12 row" *ngIf="company.length > 0">
        <div class="col-4" >
          <div class="mt-4"  *ngIf="!company[0].logo; else logo_added">
            <p class="semiboldtextblue80016 text-lefy">Logo</p>
            <img class="fit-logo-cont" src="../../assets/images/logo_ph.jpg" alt="">

            <label for="image-file" class="btn btn-formed-main-blue mt-4">Lisää logo</label>
            <input style="display:none" (change)="gotFile($event, 'logo')" type="file" accept="image/png, image/jpeg" id="image-file"/>
      
          </div>
          <ng-template #logo_added>
            <div class="col-12 p-0 mt-4">
              <div class="col-12 p-0">
                <p class="semiboldtextblue80016 text-lefy">Logo</p>
                <div class="logo-cont-hollow">
                  <img class="fit-logo-cont" src="{{company[0].logo}}" alt="">

                </div>
              </div>
            </div>
            <div class="">
              <button class="btn btn-formed-hollow mt-4" (click)="removeLogo('logo')">Poista ja vaihda</button>
    
            </div>
          </ng-template>
        </div>
        <div class="col-4">
          <div class="mt-4" style="height: 80px;" *ngIf=" !company[0].mobile_banner_image; else banner_added">
            <p class="semiboldtextblue80016 text-left">Kansikuva</p>
            <img class="fit-logo-cont" src="../../assets/images/cover_ph.jpg" alt="">
            <div class="mt-4">
              <label for="image-file-bg" class="btn btn-formed-main-blue">Lisää kansikuva</label>

            </div>
            <input style="display:none" (change)="gotFile($event, 'background')" type="file" accept="image/png, image/jpeg" id="image-file-bg"/>
      
          </div>
          <ng-template #banner_added>
            <div class="col-12 p-0 mt-4">
              <div class="col-12  p-0">
                <p class="semiboldtextblue80016 text-lefy">Kansikuva</p>
                <img  class="fit-logo-cont tenrd"  src="{{company[0].mobile_banner_image}}" alt="">
              </div>
            </div>
            <div class="d-flex">
              <p class="btn btn-formed-hollow mt-4" (click)="removeLogo('background')">Poista ja vaihda</p>
    
            </div>
          </ng-template>
        </div>
      </div>



      
      <div id="loader" class="loader-container mt-4" *ngIf="isLoading">
        <div class="loader mx-auto"></div>
        <p class="text-center pt-3">Tietoja muokataan...</p>
      </div>


      <div style="display: block;" id="form-container" *ngIf="!isLoading && company.length > 0" class="" >
        <form class="flex-row s-form mt-4" [formGroup]="form"
        (ngSubmit)="onSubmit()">
        <p class="semiboldtextblue80016 mb-1">Yrityksen nimi</p>
        <!-- Yrityksen nimi ja sukunimi -->
        <div class="col-4 row m-0 pt-2">

            <div class="form-floating mb-2  col-12 col-md-12 p-0">
                <input type="text" placeholder="Yrityksen nimi" formControlName="businessName" id="businessName" class="form-control" [class.invalid-input]="businessName.errors && businessName.touched" required>
                <label for="businessName">Yrityksen nimi</label>
                <div class="my-alerts" *ngIf="businessName.invalid && businessName.touched">
                <p class="mt-2" *ngIf="businessName.errors.required">Yritys on pakollinen</p>
                <p *ngIf="businessName.errors.businessName"> Vaaditaan kunnollinen yritys</p>
                </div>
            </div>

        </div>
        <p class="semiboldtextblue80016 mb-1 mt-4">Pääyhteyshenkilön tiedot</p>
        <p class="normaltextgray14 mb-1">Yhteystiedot eivät näy ammattilaisille. Yhteystietoja käyttää ainoastaan Formed.</p>
          <!-- Sähköposti -->
          <div class="col-12 row m-0 pt-2">
            <div class="col-4 p-0">
              <div class="form-floating mb-2  col-12 col-md-12 p-0">
                <input type="email" placeholder="Pääkäyttäjän sähköposti" formControlName="email" id="email" class="form-control" [class.invalid-input]="email.errors && email.touched" required>
                <label for="email">Pääkäyttäjän sähköposti</label>
                <div class="my-alerts" *ngIf="email.invalid && email.touched">
                <p class="mt-2" *ngIf="email.errors.required">Sähköpostiosoite on pakollinen</p>
                <p *ngIf="email.errors.email"> Vaaditaan kunnollinen businessName</p>
                </div>
            </div>
            </div>
            <div class="col-4">
              <div class="form-floating mb-2  col-12 col-md-12 p-0">
                <input type="phone" placeholder="Pääkäyttäjän puhelinnumero" formControlName="phone" id="phone" class="form-control" [class.invalid-input]="phone.errors && phone.touched" required>
                <label for="phone">Pääkäyttäjän puhelinnumero</label>
                <div class="my-alerts" *ngIf="phone.invalid && phone.touched">
                <p class="mt-2" *ngIf="phone.errors.required">Puhelinnumero on pakollinen</p>
                <p *ngIf="phone.errors.phone"> Vaaditaan kunnollinen puhelinnumero</p>
                </div>
            </div>
            </div>
            </div>

            <!-- OVT ja Operator -->
            <p class="semiboldtextblue80016 mb-1 mt-4">Laskutustiedot</p>
            <div class="col-12 row m-0 pt-2">
              <div class="col-4 p-0">
                <div class="form-floating mb-2 col-12 p-0">
                  <input type="text" placeholder="Y-tunnus" formControlName="vatID" id="vatID" class="form-control">
                  <label for="vatID">Y-tunnus</label>
              </div>
              </div>
              <div class="col-4 p-0 ps-2">
                <div class="form-floating mb-2 col-12 p-0">
                  <input type="text" placeholder="Verkkolaskuosoite" formControlName="einvoiceaddress" id="einvoiceaddress" class="form-control">
                  <label for="einvoiceaddress">Verkkolaskuosoite</label>
              </div>
              </div>
            </div>
            <div class="col-12 m-0">
              <div class="col-4">
                <div class="form-floating mb-2 col-12 p-0">
                  <input type="text" placeholder="Välittäjä" formControlName="operator" id="operator" class="form-control">
                  <label for="operator">Välittäjä</label>
              </div>
              </div>
            </div>



          <!-- sssssss -->
          <div class="col-12 row m-0 pt-2">

        </div>
        <h2 class="mt-4">Näy paremmin</h2>

        
                  <!-- Puhelin -->
                  <p class="normaltextgray14 mb-1">Lisää tähän Youtube linkki, jossa esittelet yritystäsi (valinnainen)</p>

                  <div class="col-8 row m-0 pt-2">

                    <div class="form-floating mb-2  col-12 col-md-12 p-0">
                        <input type="url" placeholder="Esittelyvideo" formControlName="description_video_url" id="description_video_url" class="form-control">
                        <label for="description_video_url">Esittelyvideo</label>
                    </div>
                </div>
                <p class="normaltextgray14 mb-1 mt-4">Lisää tähän tekstiä, jossa esittelet yritystäsi (valinnainen)</p>
                <div class="col-12 row m-0 pt-2">

                  <div class="form-floating mb-2  col-12 col-md-8 p-0">
                      <textarea style="min-height: 250px;" placeholder="Kuvaus" formControlName="description" id="description" class="form-control"></textarea>
                      <label for="descrption">Kuvaus</label>
                  </div>
              </div>


          
                
            <div class="form-inline mt-2  pt-4">
              <div class="form-group mb-2 flex-row">
                <button [disabled]="form.invalid" class="btn btn-formed-main-blue">Tallenna</button>
              </div>
            </div>
          </form>

        </div>
      </div>
</div>
</div>
</div>
</div>


